import React from "react";
import { useNavigate } from "react-router-dom";

export default function LevelSelector() {
  const navigate = useNavigate();

  const levels = [
    { label: "Level 1", path: "/codomo/mentalmath/lfive/Measurement/level1", color: "#4caf50" },
    { label: "Level 2", path: "/codomo/mentalmath/lfive/Measurement/level2", color: "#2196f3" },
    { label: "Level 3", path: "/codomo/mentalmath/lfive/Measurement/level3", color: "#ff9800" },
    { label: "Level 4", path: "/codomo/mentalmath/lfive/Measurement/level4", color: "#9c27b0" },
    { label: "Level 5", path: "/codomo/mentalmath/lfive/Measurement/level5", color: "#e91e63" }, 
  ];

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Choose Your Level</h1>
      <div style={styles.buttonGrid}>
        {levels.map((level, index) => (
          <button
            key={index}
            style={{ ...styles.button, backgroundColor: level.color }}
            onClick={() => navigate(level.path)}
          >
            {level.label}
          </button>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    textAlign: "center",
    padding: 50,
    fontFamily: "'Poppins', sans-serif",
    backgroundColor: "#f7f9fc",
    minHeight: "100vh",
  },
  heading: {
    fontSize: "2rem",
    marginBottom: 40,
    color: "#333",
  },
  buttonGrid: {
    display: "flex",
    justifyContent: "center",
    gap: 20,
    flexWrap: "wrap",
  },
  button: {
    padding: "20px 40px",
    fontSize: "1.2rem",
    borderRadius: "12px",
    border: "none",
    color: "white",
    cursor: "pointer",
    transition: "transform 0.2s, box-shadow 0.2s",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },
};
